'use client';

import { useRef } from 'react';

import { TLocale } from '@northladder/utilities';

import { IDeviceInfo } from '../../types';

/**
 * TODO: Add more app names here where this hook is called.
 */
type TDeviceChannel =
  | 'ASSET_TRACKER_WEB'
  | 'COSMETIC_DIAGNOSTICS_WEB_APP'
  | 'DEALER_WEB_APP'
  | 'DEALER_MOBILE_APP'
  | 'DEVICE_ASSESSMENT_WEB_APP'
  | 'NOT_SET';

interface IUseDeviceInfoOptions {
  channel: TDeviceChannel;
  locale: TLocale;
}

/**
 * -----------------------------------------------------------------------------
 * Retrieves the device info that is later posted alongside the auth requests.
 *  TODO: Add the channel to all places where this is called as per app name.
 * @deprecated: Remove this warning if channel is made mandatory
 */
export const useDeviceInfo = ({
  channel = 'NOT_SET',
  locale,
}: IUseDeviceInfoOptions) => {
  const deviceInfoRef = useRef<IDeviceInfo>(null);

  if (!deviceInfoRef.current?.make) {
    if (global?.navigator) {
      deviceInfoRef.current = {
        appVersion: '0.0.1',
        channel,
        locale,
        make: navigator.vendor,
        model: navigator.userAgent,
        platform: navigator.platform,
        token: 'fcm_token_not_set_for_web',
      };
    }
  }

  return deviceInfoRef.current;
};
